// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"e389c7b6","152":"7452476f","392":"88d30dc8","572":"4bb88829"}[chunkId] + ".chunk.js";
};